export class Config {
  static defaultLanguage = "pl";
}
